<ng-container
  *ngIf="
    wysiwyg.originalTranscription && !(altTextUsed$ | async);
    else textOnly
  "
>
  <app-formatted-karaoke-player [block]="wysiwyg">
  </app-formatted-karaoke-player>
</ng-container>
<ng-template #textOnly>
  <div
    class="wysiwyg-content"
    appTextSize
    style="{{ customStyle }}"
    gradeLevel="{{ gradeLevel }}"
    [innerHtml]="sanitizedHTML$ | async"
  ></div>
</ng-template>
